// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c6f32468","455":"26e9f261","743":"c3f8701f","977":"12e21737"}[chunkId] + ".chunk.js";
};